/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type UserRolesFragment = {
  __typename: "UserRoles"
  id: string
  name: string
  email: string
  roles?: Array<string> | null
}

export const UserRolesFragmentDoc = gql`
  fragment UserRoles on UserRoles {
    id
    name
    email
    roles
  }
`
